import { render, staticRenderFns } from "./OdontogramItem.vue?vue&type=template&id=7511277f&scoped=true"
import script from "./OdontogramItem.vue?vue&type=script&lang=js"
export * from "./OdontogramItem.vue?vue&type=script&lang=js"
import style0 from "./OdontogramItem.vue?vue&type=style&index=0&id=7511277f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7511277f",
  null
  
)

export default component.exports